import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import Icon from 'flarum/common/components/Icon';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import humanTime from 'flarum/common/helpers/humanTime';
import CompatBoard from './CompatBoard';
import m from 'mithril';
/**
 * One game's record across builds, newest first — shown in the board's modal
 * and on the /compatibility/:slug page, so both read the same.
 *
 * Same rule as the board: every number is people who reported that exact
 * build, and a build nobody reported on says so.
 */
export default class CompatHistory extends Component {
  loading = true;
  notFound = false;
  product = '';
  builds = [];
  oninit(vnode) {
    super.oninit(vnode);
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/launcher/compatibility/' + encodeURIComponent(this.attrs.slug)
    }).then(res => {
      this.product = res.product;
      this.builds = res.builds || [];
      this.attrs.onload?.(this.product);
    }).catch(() => {
      this.notFound = true;
    }).finally(() => {
      this.loading = false;
      m.redraw();
    });
  }
  view() {
    if (this.loading) return m(LoadingIndicator, null);
    if (this.notFound) return m("p", {
      className: "BnCompatPage-empty"
    }, "No such game.");
    return m("div", {
      className: "BnCompatHistory"
    }, m("p", {
      className: "BnCompatPage-lede"
    }, "Every build BlizzNux has seen, newest first, and what BlizzNux Launcher users reported on each. Counts are people, not posts."), m("div", {
      className: "BnCompat-list"
    }, this.builds.map(b => this.row(b))));
  }
  row(b) {
    const v = CompatBoard.verdict(b);
    const total = b.works + b.issues + b.broken;
    const parts = [];
    if (b.works) parts.push(b.works + ' working');
    if (b.issues) parts.push(b.issues + ' with issues');
    if (b.broken) parts.push(b.broken + ' broken');

    // Left: the build name (+ Live badge) over one muted summary line.
    // Right: the verdict chip, pinned to the same spot in every row.
    const inner = [m("span", {
      className: "BnBuild-main"
    }, m("span", {
      className: "BnCompat-product"
    }, m("span", {
      className: "BnCompat-name"
    }, "build ", b.build), b.live ? m("span", {
      className: "BnCompatPage-live"
    }, "Live") : null), m("span", {
      className: "BnCompat-detail"
    }, total ? [parts.join(' · '), b.lastAt ? [' · ', humanTime(b.lastAt)] : null] : 'No reports on this build', b.seenAt ? m("span", {
      className: "BnCompatPage-seen"
    }, " \xB7 released ", humanTime(b.seenAt)) : null)), m("span", {
      className: 'BnCompat-verdict BnCompat-verdict--' + v.kind,
      "aria-label": v.label
    }, m(Icon, {
      name: v.icon
    }), m("span", {
      className: "BnCompat-verdictLabel"
    }, v.label))];

    // A build with a thread links to it — that is where the individual
    // reports, failures and their logs are.
    return b.thread ? m(Link, {
      key: b.build,
      className: "BnCompat-row BnBuild-row",
      href: b.thread
    }, inner) : m("div", {
      key: b.build,
      className: "BnCompat-row BnBuild-row BnCompat-row--static"
    }, inner);
  }
}
flarum.reg.add('blizznux-home', 'forum/components/CompatHistory', CompatHistory);